export default "__VITE_ASSET__Bff$fOMp__"